import { Box, TableCell, styled } from '@mui/material';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';

const DownloadButtonSection = styled(Box)(() => ({
  display: 'flex',
  marginBottom: '8px',
  justifyContent: 'flex-end'
}));

const BoldTableCell = styled(TableCell)(() => ({
  fontWeight: 700
}));

const FilterFieldBox = styled(Box)(() => ({
  minWidth: 220
}));

const FilterActionBox = styled(Box)(() => ({
  display: 'flex',
  width: '150px',
  '@media(min-width: 1230px)': { flex: 1, justifyContent: 'end' }
}));

const TableWrapper = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto'
}));

const NumericCell = styled(Box)(() => ({
  width: '100%',
  textAlign: 'right'
}));

const TotalCell = styled(Box)(() => ({
  width: '100%',
  textAlign: 'right',
  paddingRight: '12px'
}));

const ClassHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  fontWeight: 700
}));

const SecondaryText = styled(Box)(() => ({
  fontSize: '0.75rem',
  fontWeight: 400,
  color: 'text.secondary'
}));

const LabelCell = styled(Box)<{ isBold?: boolean }>(({ isBold }) => ({
  fontWeight: isBold ? 700 : 400
}));

export {
  DownloadButtonSection,
  BoldTableCell,
  FilterFieldBox,
  FilterActionBox,
  TableWrapper,
  NumericCell,
  TotalCell,
  ClassHeaderContainer,
  SecondaryText,
  LabelCell
};

const ACCENT_BG = pallet.borderBackground;

export const reportDataGridSx = {
  ...dataGridSx(pallet),
  '& .MuiDataGrid-row.class-header': {
    backgroundColor: ACCENT_BG,
    fontWeight: 700
  },
  '& .MuiDataGrid-row.subtotal': {
    backgroundColor: ACCENT_BG,
    fontWeight: 700
  },
  '& .MuiDataGrid-row.grand-total': {
    backgroundColor: ACCENT_BG,
    fontWeight: 700
  },
  '& .MuiDataGrid-row.class-header:hover, & .MuiDataGrid-row.subtotal:hover, & .MuiDataGrid-row.grand-total:hover':
    {
      backgroundColor: ACCENT_BG
    },
  '& .MuiDataGrid-row.spacer': {
    backgroundColor: 'transparent'
  },
  '& .MuiDataGrid-row.spacer:hover': {
    backgroundColor: 'transparent'
  }
};
